// Defaults used to fill in the fields a real referee would normally choose.
// All payloads conform to the REFSIX models in `models/src/models/`:
//   - MatchEvent (base)              models/src/models/matchEvent.ts
//   - GoalEvent                      models/src/models/matchEvents/goalEvent.ts
//   - IncidentEvent                  models/src/models/matchEvents/incidentEvent.ts
//   - SubstitutionEvent              models/src/models/matchEvents/substitutionEvent.ts
//   - HalfEvent                      models/src/models/matchEvents/halfEvent.ts
//   - Team / Player / SelectedTeam   models/src/models/{team,player}.ts,
//                                    models/src/models/enums/selectedTeam.ts
//   - EventName / ReasonType         models/src/models/enums/{eventName,reasonType}.ts

import type { Player } from "refsix-js-models";

export const SINGLE_HALF_LENGTH_MS = 45 * 60 * 1000; // 45 minutes

function buildPlayers(): Player[] {
  // 11 starting players numbered 1..11, plus a single substitute on the bench (#12).
  const players: Player[] = [];
  for (let i = 1; i <= 11; i++) {
    players.push({
      name: `Player ${i}`,
      number: i,
      captain: i === 1,
      starting: true,
    } as Player);
  }
  players.push({
    name: `Player 12`,
    number: 12,
    captain: false,
    starting: false,
  } as Player);
  return players;
}

export const HOME_TEAM = {
  teamName: "Home FC",
  shortName: "HOM",
  side: "home" as const,
  color: "#4f8cff",
  players: buildPlayers(),
};

export const AWAY_TEAM = {
  teamName: "Away FC",
  shortName: "AWA",
  side: "away" as const,
  color: "#ff5a5a",
  players: buildPlayers(),
};

export function getTeam(side: "home" | "away") {
  return side === "home" ? HOME_TEAM : AWAY_TEAM;
}

// Default actors used by the simplified tester.
export const DEFAULT_GOAL_SCORER_NUMBER = 9;
export const DEFAULT_CARDED_PLAYER_NUMBER = 4;
export const DEFAULT_SUB_OFF_NUMBER = 11;
export const DEFAULT_SUB_ON_NUMBER = 12;

export function findPlayer(side: "home" | "away", number: number): Player {
  const team = getTeam(side);
  const player = team.players.find((p) => p.number === number);
  if (!player) {
    throw new Error(`No default player #${number} on ${side} team`);
  }
  return player;
}
